<script setup lang="ts">
import type { IMicroCreditTypeData } from '~/components/widget/microcredits/list/types'

const props = defineProps<{
  types: IMicroCreditTypeData[]
}>()

const { t } = useI18n()

const mappedTypes = computed(() => {
  return props.types.map((item) => ({
    ...item,
    title: t(item.title)
  }))
})
</script>

<template>
  <SidebarBlock
    v-if="props.types.length"
    :heading-text="$t('widget.select_microcredit_type.heading')"
    variant="white"
  >
    <SidebarMenu :menu-items="mappedTypes" />
  </SidebarBlock>
</template>
